import React, { useState } from 'react';
import { servicesData } from './ServicesData';
import { ChevronRight } from 'lucide-react';

const COLORS = {
  black: "#111111",
  white: "#FFFFFF",
  brown: "#C19A6B",
  grayText: "#4B4B4B",
  gold: "#C6A75E",
};

const ServicesList = () => {
  const [showAll, setShowAll] = useState(false);
  const visibleServices = showAll ? servicesData : servicesData.slice(0, 6);

  return (
    <section className="py-24 px-6 md:px-12" style={{ backgroundColor: COLORS.white }}>
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="mb-20 text-center">
          <p className="uppercase tracking-[0.4em] text-[11px]" style={{ color: COLORS.brown }}>
            Our Expertise
          </p>
          <h2 className="text-4xl md:text-6xl font-bold" style={{ color: COLORS.black }}>
            Legal <span className="font-light" style={{ color: COLORS.brown }}>Services</span>
          </h2>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {visibleServices.map((service) => (
            <div
              key={service.id}
              className="group relative p-8 rounded-2xl border transition-all duration-500 hover:-translate-y-2 shadow-lg"
              style={{ backgroundColor: COLORS.black, borderColor: COLORS.brown }}
            >
              {/* Icon */}
              <div className="text-4xl mb-6" style={{ color: COLORS.brown }}>
                {service.icon}
              </div>

              {/* Title */}
              <h3 className="text-xl font-semibold mb-3 transition-colors group-hover:text-[#C6A75E]" style={{ color: COLORS.white }}>
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-sm leading-relaxed mb-6">
                {service.shortDesc}
              </p>

              {/* Link */}
              <a
                href={`/services/${service.id}`}
                className="flex items-center gap-2 text-sm font-medium transition-colors group-hover:text-[#C6A75E]"
                style={{ color: COLORS.brown }}
              >
                Read More
                <ChevronRight size={16} />
              </a>
            </div>
          ))}
        </div>

        {/* Show More Button */}
        {servicesData.length > 6 && (
          <div className="text-center mt-12">
            <button
              onClick={() => setShowAll(!showAll)}
              className="px-8 py-3 border rounded-full text-sm font-medium transition-all duration-300"
              style={{ borderColor: COLORS.brown, color: COLORS.black, backgroundColor: COLORS.white }}
            >
              {showAll ? 'Show Less' : 'Show More'}
            </button>
          </div>
        )}

      </div>
    </section>
  );
};

export default ServicesList;